import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import ButtonIcon from './button-icon';
import Icon from './icon';
import Drawer from '../drawer';
import SubMenu from './sub-menu';

import './header-mobile.less';
import HeaderSearch from './header-search';
import HeaderCart from './header-cart';

function MenuScreen({ menuItems = [], onSelect, onClose }) {
    const onEnter = () => {
        // TODO: implement keyboard click
    };

    return (
        <ul className="menu-screen">
            <li className="menu-screen-header">
                <div className="close-container-menu">
                    <ButtonIcon
                        icon="icon-close"
                        onClick={onClose}
                        ariaLabel="Close Drawer"
                    />
                </div>
            </li>
            {menuItems.map((item, itemId) => (
                <li
                    onClick={() => onSelect(itemId)}
                    onKeyDown={onEnter}
                    key={itemId}
                >
                    {/* TODO: change <li> to an interactive element */}
                    {item.name}
                    <Icon icon="icon-forward" />
                </li>
            ))}
        </ul>
    );
}

MenuScreen.propTypes = {
    menuItems: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
};

function SubMenuScreen({ name, categories = [], onBack, onClose }) {
    return (
        <div className="submenu-screen">
            <div className="menu-screen-header">
                <ButtonIcon
                    icon="icon-back"
                    onClick={onBack}
                    ariaLabel="Go Back"
                />
                <div className="title">{name}</div>
                <div className="close-container-menu">
                    <ButtonIcon
                        icon="icon-close"
                        buttonClass="button-close"
                        onClick={onClose}
                        ariaLabel="Close Drawer"
                    />
                </div>
            </div>
            {categories.map((category, ck) => (
                <SubMenu
                    title={category.name}
                    items={category.items}
                    key={ck}
                    closeMenu={onClose}
                />
            ))}
        </div>
    );
}

SubMenuScreen.propTypes = {
    name: PropTypes.string.isRequired,
    categories: PropTypes.array.isRequired,
    onBack: PropTypes.func.isRequired,
};

export class HeaderMobile extends Component {
    static propTypes = {
        /** navigation data */
        nav: PropTypes.array.isRequired,
    };

    state = {
        openDrawer: false,
        showSubMenu: false,
        subMenuIndex: 0,
    };

    onOpen = () => {
        const { open } = this.state;
        this.setState({
            openDrawer: !open,
        });
    };

    onClose = () => {
        this.setState({
            openDrawer: false,
            showSubMenu: false,
            subMenuIndex: 0,
        });
    };

    onMenuItemClick = menuId => this.setState({ subMenuIndex: menuId, showSubMenu: true });

    onGoBack = () => this.setState({ showSubMenu: false });

    render() {
        const { openDrawer, showSubMenu, subMenuIndex } = this.state;
        const { nav } = this.props;

        return (
            <Fragment>
                <div className="menu-mobile">
                    <HeaderSearch />
                    <HeaderCart />
                    <ButtonIcon onClick={this.onOpen} icon="icon-menu" ariaLabel="Menu" />
                </div>
                <Drawer open={openDrawer} onClose={this.onClose} position="right" overlay>
                    <div className="drawer-container">
                        {showSubMenu ? (
                            <SubMenuScreen
                                name={nav[subMenuIndex].name}
                                categories={nav[subMenuIndex].categories}
                                onBack={this.onGoBack}
                                onClose={this.onClose}
                            />
                        ) : (
                            <MenuScreen menuItems={nav} onClose={this.onClose} onSelect={this.onMenuItemClick} />
                        )}
                    </div>
                </Drawer>
            </Fragment>
        );
    }
}

export default HeaderMobile;
